module.exports = __webpack_public_path__ + "static/media/fan4_lamp0.01244d27.gif";